<template>
  <transition name="navBarMobile-fade">
    <div v-if="modelValue" class="navBarMobile">
      <div class="navBarMobile_drawer">
        <div class="navBarMobile_header">
          <router-link :to="{ name: PAGE_NAME.HOME }" class="navBarMobile_logo" @click="close">
            <div
              :class="['navBarMobile_logoImg', `-${projectId}`]"
              :style="{
                backgroundImage: `url(${logo.src})`,
                maskImage: `url(${logo.src})`
              }"
            />
          </router-link>
        </div>

        <div class="navBarMobile_profile">
          <img :src="user.avatar" alt="" class="navBarMobile_avatar">
          <div class="navBarMobile_profileWrapper" @click.stop="profileExpanded = !profileExpanded">
            <div class="navBarMobile_profileInfo">
              <span class="navBarMobile_name">{{ username }}</span>
              <points-label :points="userScoreAmount" only-text class="navBarMobile_points" />
            </div>
            <div class="navBarMobile_chevron" :class="{ '-open': profileExpanded }">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_21390_13964)">
                <g clip-path="url(#clip1_21390_13964)">
                <path d="M3.5 7L10 13L16.5 7" stroke="#697076" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </g>
                <defs>
                <clipPath id="clip0_21390_13964">
                <rect width="20" height="20" fill="white"/>
                </clipPath>
                <clipPath id="clip1_21390_13964">
                <rect width="20" height="20" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div v-if="profileExpanded" class="navBarMobile_profileSub">
          <router-link
            :to="{ name: PAGE_NAME.EDIT_PROFILE }"
            class="navBarMobile_item"
            exact-active-class="-active"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -userEdit" />
            </div>
            {{ $t('editProfile') }}
          </router-link>
          <router-link
            :to="{ name: PAGE_NAME.POINTS }"
            class="navBarMobile_item"
            :class="{ '-active': isActivePoints }"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -points" />
            </div>
            {{ $t('Points') }} {{ projectName }}
          </router-link>
        </div>

        <nav class="navBarMobile_nav">
          <router-link
            :to="{ name: PAGE_NAME.HOME }"
            class="navBarMobile_item"
            exact-active-class="-active"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -home" />
            </div>
            {{ $t('crumb.general') }}
          </router-link>
          <router-link
            :to="{ name: PAGE_NAME.SUPPORT }"
            class="navBarMobile_item"
            exact-active-class="-active"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -support" />
            </div>
            {{ $t('supportCenter') }}
          </router-link>
          <router-link
            :to="{ name: PAGE_NAME.SUBSCRIPTIONS }"
            class="navBarMobile_item"
            exact-active-class="-active"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -subscriptions" />
            </div>
            {{ $t('Subscriptions') }}
          </router-link>
        </nav>

        <div class="navBarMobile_divider" />

        <div class="navBarMobile_system">
          <div class="navBarMobile_systemTitle">{{ $t('system') }}</div>
          <div
            class="navBarMobile_settingsTrigger"
            :class="{ '-open': settingsExpanded }"
            @click="settingsExpanded = !settingsExpanded"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -settings" />
            </div>
            <div class="navBarMobile_settingsTriggerText">
              <span class="navBarMobile_itemText">{{ $t('Settings') }}</span>
              <div class="navBarMobile_chevron" :class="{ '-open': settingsExpanded, '-active': settingsExpanded }">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_21390_13964)">
                  <g clip-path="url(#clip1_21390_13964)">
                  <path d="M3.5 7L10 13L16.5 7" stroke="#697076" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  </g>
                  <defs>
                  <clipPath id="clip0_21390_13964">
                  <rect width="20" height="20" fill="white"/>
                  </clipPath>
                  <clipPath id="clip1_21390_13964">
                  <rect width="20" height="20" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <transition name="navBarMobile-slide">
            <div v-if="settingsExpanded" class="navBarMobile_settingsSub">
              <router-link
                :to="{ name: PAGE_NAME.SETTINGS_REMINDERS_TRAINING }"
                class="navBarMobile_settingsItem"
                exact-active-class="-active"
              >
                {{ $t('reminderTraining') }}
              </router-link>
              <router-link
                :to="{ name: PAGE_NAME.SETTINGS_SOCIAL_NETWORKS }"
                class="navBarMobile_settingsItem"
                exact-active-class="-active"
              >
                {{ $t('addLoginMethods') }}
              </router-link>
              <router-link
                :to="{ name: PAGE_NAME.SETTINGS_NOTIFICATIONS }"
                class="navBarMobile_settingsItem"
                exact-active-class="-active"
              >
                {{ $t('notificationSettings') }}
              </router-link>
              <router-link
                :to="{ name: PAGE_NAME.SETTINGS_USER_PAYMENT_METHODS }"
                class="navBarMobile_settingsItem"
                exact-active-class="-active"
              >
                {{ $t('userPaymentMethods.title') }}
              </router-link>
              <router-link
                v-if="isShowInstallments"
                :to="{ name: PAGE_NAME.INSTALLMENTS }"
                class="navBarMobile_settingsItem"
                exact-active-class="-active"
              >
                {{ $t('installments.shortTitle') }}
              </router-link>
            </div>
          </transition>
          <lang-selector
            v-if="canChangeLang"
            fromMenu="navBarMobile"
          />
          <router-link
            :to="{ name: PAGE_NAME.LOGOUT }"
            class="navBarMobile_item"
            @click="close"
          >
            <div class="navBarMobile_iconWrapper">
              <i class="navBarMobile_icon -logout" />
            </div>
            {{ $t('exit') }}
          </router-link>
        </div>
      </div>
      <button type="button" class="navBarMobile_close" aria-label="Close" @click="close">
        <div class="navBarMobile_close-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_21390_14226)">
            <path d="M4 4L16 16M16 4L4 16" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            </g>
            <defs>
            <clipPath id="clip0_21390_14226">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </div>
      </button>
      <div class="navBarMobile_overlay" aria-hidden="true" @click="close" />
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useStore } from '@web/store'

import PAGE_NAME from '@web/consts/PAGE_NAME'
import PointsLabel from '@web/platform.v3/components/pointsLabel.vue'
import LangSelector from '@web/platform.v3/components/menu/langSelector.vue'
import { specialProjectId } from '@web/common/ExternalConfig/getters'
import locale from '@web/common/locale'

const POINTS_ROUTES = [PAGE_NAME.POINTS, PAGE_NAME.POINTS_HISTORY]
const PROFILE_ROUTES = [PAGE_NAME.EDIT_PROFILE]
const SETTINGS_ROUTES = [
  PAGE_NAME.SETTINGS_REMINDERS_TRAINING,
  PAGE_NAME.SETTINGS_SOCIAL_NETWORKS,
  PAGE_NAME.SETTINGS_NOTIFICATIONS,
  PAGE_NAME.SETTINGS_USER_PAYMENT_METHODS
]

defineOptions({
  name: 'NavBarMobile'
})

defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const route = useRoute()
const store = useStore()
const projectId = computed(() => specialProjectId())
const user = computed(() => store.getters['user/user'])
const username = computed(() => store.getters['user/username'])
const logo = computed(() => store.getters['assets/logo'])
const userScoreAmount = computed(() => store.getters['userScore/amount'])
const projectName = computed(() => store.getters['assets/projectTitle'])
const isActivePoints = computed(() => POINTS_ROUTES.includes(route.name as string))
const isShowInstallments = computed(() => store.getters['installments/isLoaded'] && !store.getters['installments/isEmpty'])
const canChangeLang = computed(() => locale.SUPPORTED_LANGUAGE.length > 1)

const profileExpanded = ref(false)
const settingsExpanded = ref(false)

watch(
  () => route.name,
  (name) => {
    profileExpanded.value = PROFILE_ROUTES.includes(name as string) || POINTS_ROUTES.includes(name as string)
    settingsExpanded.value = SETTINGS_ROUTES.includes(name as string)
  },
  { immediate: true }
)

function close () {
  emit('update:modelValue', false)
}
</script>

<style lang="scss" scoped>
@import '@web/assets/scss/textContsnts.scss';

.navBarMobile {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: space-between;

  &_close {
    position: relative;
    z-index: 2;
    flex-shrink: 0;
    width: 70px;
    height: 70px;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    &-icon {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      padding: 10px;
      background: rgba(0, 0, 0, .7);
      border-radius: 50%;
    }
  }

  &_overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, .7);

  }

  &_drawer {
    width: 100%;
    max-width: 300px;
    background: var(--ac-color-white);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    animation: navBarMobile-slideIn 0.25s ease;
    position: relative;
    z-index: 2;
    padding: 12px 20px 32px;
  }

  &_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    padding-bottom: 6px;
    border-bottom: 1px solid #EEEEEE;
  }

  &_logo {
    display: block;
    flex: 1;
    padding: 10px;
  }

  &_logoImg {
    width: 162px;
    height: 35px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left center;
    mask-position: left center;
    mask-size: contain;
    mask-repeat: no-repeat;

    &.-any {
      background-color: #A990E2;
      background-image: none !important;
    }
  }

  &_profile {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
    padding: 16px 0 12px;
    border-bottom: 1px solid #EEEEEE;
  }

  &_avatar {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    flex-shrink: 0;
  }

  &_profileWrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  &_profileInfo {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    gap: 2px;
  }

  &_name {
    @extend .text-base;
    color: var(--ac-color-black);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &_chevron {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    transition: transform 0.2s;

    &.-open {
      transform: rotate(180deg);
    }

    &.-active {
      svg path {
        stroke: var(--ac-color-deep-liliac);
      }
    }
  }

  &_profileSub {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
    border-bottom: 1px solid #EEEEEE;
    gap: 10px;
  }

  &_divider {
    height: 1px;
    background: #EEEEEE;
    width: 100%;
  }

  &_nav {
    display: flex;
    flex-direction: column;
    padding: 22px 0 32px;
    gap: 10px;
  }

  &_item {
    display: flex;
    align-items: center;
    gap: 10px;
    @extend .text-sm;
    color: var(--ac-color-dark-gray);
    text-decoration: none;
    transition: background 0.2s;
    border-radius: 6px;
    overflow: hidden;

    &:active,
    &.-active {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }

    &:hover:not(&.-active) {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }
  }

  &_settingsTrigger {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    @extend .text-sm;
    color: var(--ac-color-dark-gray);
    transition: background 0.2s;
    border-radius: 6px;
    overflow: hidden;

    &:active {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }

    &.-open {
      background: var(--ac-color-liliac-secondary);
      color: var(--ac-color-deep-liliac);
    }

    &:hover:not(&.-open) {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }
  }

  &_settingsTriggerText {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    padding: 10px 22px 10px 0;
  }

  &_itemText {
    flex: 1;
  }

  &_iconWrapper {
    width: 40px;
    height: 40px;
    padding: 8px;
    flex-shrink: 0;
    background-color: transparent;
    border-radius: 6px;
    overflow: hidden;
  }

  &_item.-active &_iconWrapper,
  &_settingsTrigger.-open &_iconWrapper {
    background-color: var(--ac-color-deep-liliac);
  }

  &_icon {
    display: block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position: center;
    background-color: var(--ac-color-liliac-accent);

    &.-home {
      mask-image: url(~@web/assets/images/menu/icon-menu-main.svg);
    }

    &.-support {
      mask-image: url(~@web/assets/images/menu/icon-menu-support.svg);
    }

    &.-subscriptions {
      mask-image: url(~@web/assets/images/menu/icon-menu-subscriptions.svg);
    }

    &.-settings {
      mask-image: url(~@web/assets/images/menu/icon-menu-settings.svg);
    }

    &.-logout {
      mask-image: url(~@web/assets/images/menu/icon-menu-logout.svg);
    }

    &.-userEdit {
      mask-image: url(~@web/assets/images/menu/icon-menu-profile-edit-new.svg);
    }

    &.-points {
      mask-image: url(~@web/assets/images/menu/icon-menu-points-new.svg);
    }
  }

  &_item.-active &_icon,
  &_settingsTrigger.-open &_icon {
    background-color: var(--ac-color-white);
  }

  &_system {
    padding: 12px 0;
    display: flex;
    flex-direction: column;
  }

  &_systemTitle {
    @extend .text-xs;
    color: var(--ac-color-gray);
    margin-bottom: 6px;
  }

  &_settingsSub {
    padding: 8px 0 4px;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &_settingsItem {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 10px;
    @extend .text-sm;
    color: var(--ac-color-dark-gray);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 50px;
    text-decoration: none;
    transition: background 0.2s;
    border-radius: 6px;
    overflow: hidden;

    &:active,
    &.-active {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }

    &:hover:not(&.-active) {
      background-color: #F8F8F9;
      color: var(--ac-color-black);
    }
  }
}

.navBarMobile-fade-enter-active,
.navBarMobile-fade-leave-active {
  transition: opacity 0.25s;
}

.navBarMobile-fade-enter-from,
.navBarMobile-fade-leave-to {
  opacity: 0;
}

.navBarMobile-slide-enter-active,
.navBarMobile-slide-leave-active {
  transition: all 0.2s ease;
}

.navBarMobile-slide-enter-from,
.navBarMobile-slide-leave-to {
  opacity: 0;
}

@keyframes navBarMobile-slideIn {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
